import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tKgpco/Store/CustomHandlerCreator";

type SearchFilterKeys = "selectFilter" | "selectFilterText";
type SearchFilterActionType = {
    key: SearchFilterKeys;
    value: string;
};
type HandlerType = CustomHandler<SearchFilterActionType>;

export const SetAccessorialFilter: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/SetSearchFilter", filters: props.parameter });
};

export const chain = [SetAccessorialFilter];

const setAccessorialSearchFilter = createHandlerChainRunner(chain, "SetAccessorialSearchFilter");
export default setAccessorialSearchFilter;
